export function Marquee({ items }) {
  const row = [...items, ...items];
  return (
    <div className="relative overflow-hidden border-y border-gray-200 bg-white py-7 select-none">
      <div className="flex w-max gap-8 whitespace-nowrap animate-marquee will-change-transform">
        {row.map((t, i) => (
          <span
            key={i}
            className="inline-flex items-center gap-8 text-2xl sm:text-4xl font-heading font-semibold tracking-tight text-gray-900"
          >
            <span>{t}</span>
            <span className="text-gray-300 text-xl">/</span>
          </span>
        ))}
      </div>
    </div>
  );
}
